import { cn } from "../lib/util.js";

const FIVE = "★★★★★";

/* 별 다섯 개를 겹쳐 그린다 — 아래는 빈 별, 위는 채운 별을 점수만큼 너비로 잘라낸다.
   ★ 글리프는 반쪽을 그릴 수 없어서(한 글자가 최소 단위) 3.7점 같은 소수를 표현하려면
   자르는 수밖에 없다. 같은 문자·같은 폰트를 겹치니 글자 폭이 정확히 맞는다.

   점수는 옆에 숫자로 이미 나와 있으므로 별은 장식이다 → aria-hidden. */
export function Stars({ score, className }) {
  const pct = (Math.min(5, Math.max(0, score)) / 5) * 100;
  return (
    <span
      className={cn("relative inline-block whitespace-nowrap leading-none", className)}
      aria-hidden="true"
    >
      <span className="text-input">{FIVE}</span>
      <span
        className="absolute inset-y-0 left-0 overflow-hidden text-star"
        style={{ width: `${pct}%` }}
      >
        {FIVE}
      </span>
    </span>
  );
}
